"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var AbsoluteFill_1 = require("./AbsoluteFill");

var rotate = {
  transform: "rotate(90deg)"
};
var ICON_SIZE = 40;
var label = {
  color: '#555',
  fontSize: 14,
  fontFamily: 'sans-serif'
};
var container = {
  justifyContent: 'center',
  alignItems: 'center'
};

var Loading = function Loading() {
  return (0, jsx_runtime_1.jsxs)(AbsoluteFill_1.AbsoluteFill, {
    style: container,
    id: "remotion-comp-loading",
    children: [(0, jsx_runtime_1.jsx)("style", {
      type: "text/css",
      children: "\n\t\t\t\t@keyframes anim {\n\t\t\t\t\tfrom {\n\t\t\t\t\t\topacity: 0\n\t\t\t\t\t}\n\t\t\t\t\tto {\n\t\t\t\t\t\topacity: 1\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t#remotion-comp-loading {\n\t\t\t\t\tanimation: anim 2s;\n\t\t\t\t\tanimation-fill-mode: forwards;\n\t\t\t\t}\n\t\t\t"
    }), (0, jsx_runtime_1.jsx)("svg", {
      width: ICON_SIZE,
      height: ICON_SIZE,
      viewBox: "-100 -100 400 400",
      style: rotate,
      children: (0, jsx_runtime_1.jsx)("path", {
        fill: "#555",
        stroke: "#555",
        strokeWidth: "100",
        strokeLinejoin: "round",
        d: "M 2 172 a 196 100 0 0 0 195 5 A 196 240 0 0 0 100 2.259 A 196 240 0 0 0 2 172 z"
      })
    }), (0, jsx_runtime_1.jsx)("p", {
      style: label,
      children: "Loading..."
    })]
  });
};

exports.Loading = Loading;